export default __webpack_public_path__ + "static/media/Polygon.838d8aad.svg";